<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <div class="w-full max-w-[400px] px-16 pt-10 pb-16">
    <div class="mb-4 flex justify-center">
      <img :src="nordyLogo" class="h-12" />
    </div>

    <div class="mb-10 text-center text-[14px]">
      <p>{{ t.subTitle }}</p>
    </div>

    <div class="mx-auto max-w-[240px] space-y-4">
      <GoogleLoginButton @login-success="handleSocialLoginSuccess" />
      <DiscordLoginButton @login-success="handleSocialLoginSuccess" />
    </div>

    <div class="mt-6 text-center text-[14px] text-pretty text-gray-500">
      {{ t.desc1 }}
      <a class="hover:underline" href="/terms/use" target="_blank">
        {{ t.terms }}
      </a>
      {{ t.and }}
      <a
        class="font-bold hover:underline"
        href="/terms/privacy"
        target="_blank"
      >
        {{ t.privacy }}
      </a>
      {{ t.desc2 }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { nordyApi } from '@/nordy/api'
import nordyLogo from '@/nordy/assets/nordy-logo-new.png'
import { useNordyUserStore } from '@/nordy/store/nordyUserStore'
import { useToastStore } from '@/platform/updates/common/toastStore'
import { useDialogStore } from '@/stores/dialogStore'

import DiscordLoginButton from './DiscordLoginButton.vue'
import GoogleLoginButton from './GoogleLoginButton.vue'

const texts = {
  ko: {
    subTitle:
      '로그인 또는 회원가입 해주세요. Nordy를 무료로 사용할 수 있습니다.',
    desc1: '로그인 시 nordy의',
    terms: '이용약관',
    and: '및',
    privacy: '개인정보처리방침',
    desc2: '에 동의한 것으로 간주합니다.'
  },
  en: {
    subTitle: 'Please log in or sign up. You can use Nordy for free.',
    desc1: "By signing in, you are indicating your agreement with nordy's",
    terms: 'terms and conditions',
    and: 'and',
    privacy: 'privacy policy',
    desc2: ''
  }
}

const nordyUserStore = useNordyUserStore()
const t = computed(() =>
  nordyUserStore.nordyUser?.language === 'ko' ? texts.ko : texts.en
)

const messageStore = useToastStore()
const dialogStore = useDialogStore()

async function handleSocialLoginSuccess() {
  const user = await nordyUserStore.reloadNordyUser()
  if (!user) return

  const { hasWorkflow, parameter } = nordyApi.hasWorkflowParameter()
  if (
    hasWorkflow &&
    parameter &&
    !sessionStorage.getItem(`parameterWorkflowLoaded_${parameter}`)
  ) {
    window.location.reload()
    return
  }

  //!nordy - 크레딧 로드 실패 시 재시도 (실패하면 totalAmount: 0으로 잘못 표시됨)
  for (let attempt = 0; attempt < 3; attempt++) {
    const { success } = await nordyUserStore.getActiveCredit()
    if (success) break
  }
  messageStore.add({
    severity: 'success',
    summary: 'Successfully logged in',
    detail: 'Successfully logged in',
    life: 3000
  })
  dialogStore.closeDialog({ key: 'nordy-login' })
}
</script>
